export const formWrapperStyles = {
  padding: '0 24px 24px',
  backgroundColor: ({ palette }) => palette.background.secondary,
};
